<template>
  <DialogTitle
    data-slot="dialog-title"
    v-bind="forwardedProps"
    :class="cn('text-primary text-lg leading-none font-semibold', props.class)"
  >
    <slot />
  </DialogTitle>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import { DialogTitle, type DialogTitleProps, useForwardProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<
  DialogTitleProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>
